import SinotransRegistrationFormProperties from './SinotransRegistrationFormProperties'
import SinotransRegistrationApiUrls from 'src/apiUrls/SinotransRegistrationApiUrls'
import { components } from 'cng-web-lib'
import React from 'react'

const {
    form: { CngEditForm }
} = components

function SinotransRegistrationEditForm({
    showNotification,
    id,
    onFetchPreSuccess = () => {
        //do nothing
     }
}) {
    return (
        <CngEditForm
            fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
            showNotification={showNotification}
            bodySection={
                <SinotransRegistrationFormProperties.Fields
                    showNotification={showNotification}
                />
            }
            formikProps={SinotransRegistrationFormProperties.formikProps}
            toClientDataFormat={SinotransRegistrationFormProperties.toClientDataFormat}
            toServerDataFormat={SinotransRegistrationFormProperties.toServerDataFormat}
            fetch={{
                url: SinotransRegistrationApiUrls.GET,
                onPreSuccess: onFetchPreSuccess
            }}
            update={{
                url: SinotransRegistrationApiUrls.PUT
            }}
            id={id}
        />
    )
}

export default SinotransRegistrationEditForm
